/**
 * Email allowlist for the Tally Sync admin console.
 *
 * Keep this list in sync with the backend's `TALLY_ALLOWED_EMAILS` env
 * var (default `aa@crystalgroup.in`). This is a UI-only cosmetic gate:
 * the API still enforces the email check server-side, so even a power
 * user who hard-edits the bundle to flip `isTallyAllowed → true` gets
 * a 403 from every /api/tally/* call.
 */
const ALLOW = new Set<string>([
  'aa@crystalgroup.in',
]);

export function isTallyAllowed(email: string | undefined | null): boolean {
  if (!email) return false;
  return ALLOW.has(String(email).trim().toLowerCase());
}
